var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutrition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64318",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21C10.05 21 8.39583 20.3209 7.0375 18.9625C5.67917 17.6042 5 15.95 5 14C5 12.4334 5.4625 11.0292 6.3875 9.78754C7.3125 8.54587 8.525 7.70837 10.025 7.27504C9.69167 7.1917 9.36667 7.07087 9.05 6.91254C8.73333 6.7542 8.45 6.55004 8.2 6.30004C7.65 5.75004 7.29583 5.09587 7.1375 4.33754C6.97917 3.5792 6.94167 2.80837 7.025 2.02504C7.80833 1.9417 8.57917 1.9792 9.3375 2.13754C10.0958 2.29587 10.75 2.65004 11.3 3.20004C11.6833 3.58337 11.9625 4.0167 12.1375 4.50004C12.3125 4.98337 12.425 5.4917 12.475 6.02504C12.6917 5.50837 12.9542 5.02087 13.2625 4.56254C13.5708 4.1042 13.9167 3.68337 14.3 3.30004C14.4833 3.1167 14.7167 3.02504 15 3.02504C15.2833 3.02504 15.5167 3.1167 15.7 3.30004C15.8833 3.48337 15.975 3.7167 15.975 4.00004C15.975 4.28337 15.8833 4.5167 15.7 4.70004C15.3333 5.0667 15.0083 5.47087 14.725 5.91254C14.4417 6.3542 14.2333 6.82504 14.1 7.32504C15.5667 7.7917 16.75 8.63754 17.65 9.86254C18.55 11.0875 19 12.4667 19 14C19 15.95 18.3208 17.6042 16.9625 18.9625C15.6042 20.3209 13.95 21 12 21ZM12 19C13.3833 19 14.5625 18.5125 15.5375 17.5375C16.5125 16.5625 17 15.3834 17 14C17 12.6167 16.5125 11.4375 15.5375 10.4625C14.5625 9.48754 13.3833 9.00004 12 9.00004C10.6167 9.00004 9.4375 9.48754 8.4625 10.4625C7.4875 11.4375 7 12.6167 7 14C7 15.3834 7.4875 16.5625 8.4625 17.5375C9.4375 18.5125 10.6167 19 12 19Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/Nutrition.a746dd4f.svg";
export { ForwardRef as ReactComponent };